module.exports = {
    config: {
        '/api': {
            // target: 'http://127.0.0.1:2100/web/', // 开发
            // target: 'https://anysonus.com/api/', // 生产
            target: 'http://39.99.151.131:2100/web/', // 生产
            changeOrigin: true,  // 跨域
            pathRewrite: {
                '^/api': ''
            }
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./config/proxy.js
// module id = nmtd
// module chunks = 1